import type { ReactNode } from 'react';

/** The labs every account has, as the student app's catalogue names them
 *  (`student-app/src/pages/labs/labCatalog.ts`) and the teacher app's
 *  Simulations page shows them. The gated Stoichiometry lab is left out. */
const LABS: { title: string; subject: string; blurb: string }[] = [
  { title: 'Chemistry Lab', subject: 'Chemistry', blurb: 'Mix anything, heat it, test it — and see what happens.' },
  { title: 'Mechanics Bench', subject: 'Physics', blurb: 'Build pulleys, ramps and springs, and read every force.' },
  { title: 'Optics Bench', subject: 'Physics', blurb: 'Place lenses, mirrors and prisms, and find where the image forms.' },
  { title: 'Simulations', subject: 'Physics · Chemistry', blurb: 'Change a quantity and watch the concept respond.' },
];

/**
 * The labs, on each front-door page — the same four labs, told to whoever the
 * page is for: the hub, `/students` and `/teachers` pass their own heading.
 */
export function LabsSection({ title, lead, tint }: { title: string; lead: ReactNode; tint?: boolean }) {
  return (
    <section className={`fd-section${tint ? ' fd-section--tint' : ''}`}>
      <div className="fd-wrap">
        <p className="fd-eyebrow">Labs</p>
        <h2 className="fd-h2">{title}</h2>
        <p className="fd-lead">{lead}</p>
        <ul className="fd-grid fd-labs">
          {LABS.map((lab) => (
            <li key={lab.title} className="fd-card fd-card--pad">
              <div className="fd-kicker">{lab.subject}</div>
              <h3 className="fd-h3">{lab.title}</h3>
              <p className="fd-p">{lab.blurb}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
